import type { ConfirmedRarity } from "../catalog/rarity";

const LABELS: Record<ConfirmedRarity, string> = {
  STH: "STH",
  TH: "TH",
  Exclusive: "Exclusive",
};

type RarityBadgeProps = {
  rarity: ConfirmedRarity;
};

export function RarityBadge({ rarity }: RarityBadgeProps) {
  return (
    <span className={`hw-rarity hw-rarity--${rarity.toLowerCase()}`}>
      {LABELS[rarity]}
    </span>
  );
}
